<script>
import { defineComponent } from 'vue'
import TwContainer from '@/components/generic/tw-container.vue'
import TwInput from '@/components/generic/forms/tw-input.vue'
import TwWysiwyg from '@/components/generic/forms/tw-wysiwyg.vue'
import TwButton from '@/components/generic/tw-button.vue'
import BatchMonitor from '@/components/batches/batch-monitor.vue'
import loggedInUserMixin from '@/mixins/loggedInUserMixin.js'

export default defineComponent({
  name: 'SendEmailNotificationsPage',
  components: { BatchMonitor, TwButton, TwWysiwyg, TwInput, TwContainer },
  mixins:[loggedInUserMixin],
  data() {
    return {
      ValidationErrorMessage:null,
      SubjectLine: '',
      Message: '',
      LoadingSendingPreview: false,
      LoadingSendingEmails: false,
      Batch: null,
    }
  },
  computed: {
    canBeSent() {
      return this.SubjectLine.trim() !== '' && this.Message.trim() !== '';
    }
  },
  beforeMount () {
    if(!this.loggedInUser.admin) {
      this.$router.push({ name: 'DashboardPage' })
      this.$notify('You do not have permission to access this page', 'error')
    }
  },
  methods: {
    async batchFinished() {
      this.Batch = null
      this.$notify('All emails sent out')
    },
    async sendPreview() {
      if (!this.canBeSent) {
        this.$notify('Please fill in the subject line and message', 'error')
        return
      }
      try {
        this.ValidationErrorMessage = null
        this.LoadingSendingPreview = true

        const { data } = await axios.post('/api/v1/send-email-notifications-to-organizations-preview', {
          subject: this.SubjectLine,
          message: this.Message
        })
        this.$notify('Preview sent to your email', 'info')
        this.LoadingSendingPreview = false
      } catch (e) {
        console.error(e)
        this.LoadingSendingPreview = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    },
    async sendEmails() {
      if (!this.canBeSent) {
        this.$notify('Please fill in the subject line and message', 'error')
        return
      }
      if (!confirm('Are you sure you want to send this email to all verified organizations? THIS IS NOT REVERSIBLE!')) {
        return
      }
      try {
        this.ValidationErrorMessage = null
        this.LoadingSendingEmails = true
        const { data } = await axios.post('/api/v1/send-email-notifications-to-organizations', {
          subject: this.SubjectLine,
          message: this.Message
        })
        this.Batch = data
        this.$notify('ALL EMAILS SENT!', 'info')
        this.LoadingSendingEmails = false
      } catch (e) {
        console.error(e)
        this.LoadingSendingEmails = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    }
  }
})
</script>

<template>
  <tw-container>
    <batch-monitor v-if="Batch" v-model="Batch" @finished="batchFinished" />
    <tw-input v-model="SubjectLine" :disabled="LoadingSendingEmails || LoadingSendingPreview" label="Subject Line" />
    <tw-wysiwyg v-model="Message" :disabled="LoadingSendingEmails || LoadingSendingPreview" label="Contents:" />
    <div class="flex justify-end gap-2 mt-4">
      <tw-button size="lg" :loading="LoadingSendingPreview" @click="sendPreview">
        Send to myself
      </tw-button>
      <tw-button size="lg" :loading="LoadingSendingEmails" variant="danger" @click="sendEmails">
        Send to all verified organizations
      </tw-button>
    </div>
  </tw-container>
</template>

<style scoped>

</style>
